/*eslint-disable*/
import React from 'react';
import { Dropdown } from 'semantic-ui-react'



const VehicleOwnershipTypeDropdown = ({
        field: { name },
        form: { setFieldValue },
        ...props
    }) => {
        
        let vehicleOwnerType = [
            {
                vehicleOwnershipTypeId: 1,
                vehicleOwnershipTypeName: "Market",
            },
            {
                vehicleOwnershipTypeId: 2,
                vehicleOwnershipTypeName: "Owned",
            }
        ]
        

        let options = []
        if (vehicleOwnerType && vehicleOwnerType.length > 0) {
            vehicleOwnerType.map((object, index) => {
                let temp = {}
                temp.key = object.vehicleOwnershipTypeId
                temp.text = object.vehicleOwnershipTypeName
                temp.value = object.vehicleOwnershipTypeName
                return options[index] = temp
            })
        }

    return (
        <Dropdown
            selection
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            clearable
            search
            {...props}
            fluid
        />

    )
}

export default VehicleOwnershipTypeDropdown